export const tecnicas = [
    {
        img: 'media/sublimado.jpg',
        title: "Sublimado",
        tech: "sublimado",
        properties: [
            "Para prendas grises o blancas",
            "Ideal para diseños full color o con detalles finos"
        ]
    },
    {
        img: 'media/bordado.jpg',
        title: "Bordado",
        tech: "bordado",
        properties: [
            "Adaptable a cualquier tipo de prenda",
            "Diseños versátiles, sencillos o complejos"
        ]        
    },
    {
        img: 'media/estampado.jpg',
        title: "Estampado",
        tech: "estampado",
        properties: [
            "Ideal para telas naturales",
            "Adecuado para diseños de pocos colores"
        ]    
    },
]